import { render, staticRenderFns } from "./reflect-shaded.vue?vue&type=template&id=748aff60"
import script from "./reflect-shaded.vue?vue&type=script&lang=js"
export * from "./reflect-shaded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports